import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useCancelInvoice(
  onSuccess: () => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const cancelInvoiceMutation = useMutation({
    ...trpc.invoices.cancel.mutationOptions(),
    onSuccess,
    onError,
  });

  const cancelInvoice = (
    merchantid: string,
    invoiceId: string,
    callbacks?: { onSettled?: () => void }
  ) => {
    cancelInvoiceMutation.mutate(
      { rentalsMerchantId: merchantid, id: invoiceId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: trpc.invoices.list.queryKey() });
          callbacks?.onSettled?.();
        },
        onError: () => {
          callbacks?.onSettled?.();
        },
      }
    );
  };

  return { cancelInvoice };
}
